import { ref } from 'vue'

import type { ColumnKey } from '@/typings/twitter_benchmark_campaign_posts'

import { useTwBenchmarkTableSettingsStore } from '../store/useTwBenchmarkTableSettingsStore'
import { DEFAULT_TABLE_COLUMNS } from '../utils/columns'

/**
 * 表示列カスタマイズ
 */
export function useTableSettings() {
  const settingsStore = useTwBenchmarkTableSettingsStore()

  const draftOrder = ref<ColumnKey[]>([...settingsStore.columnOrder])

  const open = (): void => {
    draftOrder.value = [...settingsStore.columnOrder]
  }

  const toggle = (column: ColumnKey): void => {
    const index = draftOrder.value.indexOf(column)
    if (index === -1) {
      draftOrder.value = [...draftOrder.value, column]
    } else {
      draftOrder.value = draftOrder.value.filter(key => key !== column)
    }
  }

  const reorder = (newOrder: ColumnKey[]): void => {
    draftOrder.value = [...newOrder]
  }

  const save = async (): Promise<boolean> => {
    return settingsStore.save(draftOrder.value)
  }

  const cancel = (): void => {
    draftOrder.value = [...settingsStore.columnOrder]
  }

  const resetToDefault = (): void => {
    draftOrder.value = DEFAULT_TABLE_COLUMNS.map(column => column.key)
  }

  const isVisibleInDraft = (column: ColumnKey): boolean => {
    return draftOrder.value.includes(column)
  }

  return {
    draftOrder,
    open,
    toggle,
    reorder,
    save,
    cancel,
    resetToDefault,
    isVisibleInDraft
  }
}
